import Status from 'clarks/components/ivu-table/status'

let forms = {
   addDashboard: {
      icon: 'fa fa-university',
      title: 'Add Dashboard',
      subtitle: 'Provide Dashboard Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "code", label: "Code", },
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "name", label: "Name", },
         { type: "select", class: "col-12", filterable: false, multiple: true, clearable: true, options: [], validation: "required", model: "visuals", label: "Visuals", max_tag_count: 1},
         { type: "select", class: "col-12", filterable: false, multiple: true, clearable: true, options: [], validation: "", model: "filters", label: "Filters", max_tag_count: 1},
         { type: "select", class: "col-12", filterable: false, multiple: true, clearable: true, options: [], validation: "", model: "roles", label: "Roles", max_tag_count: 1},
         { type: "checkbox", class: "col-12 custom-check", validation: "required", model: "is_main_dashboard", label: "Is Main Dashboard", },
         { type: "textarea", class: "col-12", rows: "3", validation: "required|min:10|max:2000", model: "description", label: "Description", },

      ]
   },
   editDashboard: {
      icon: 'fa fa-university',
      title: 'Edit Dashboard',
      subtitle: 'Update Dashboard Details',
      forms: [
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "code", label: "Code", },
         { type: "text", form_type: "text", class: "col-12 col-md-6", validation: "required|min:3|max:100", model: "name", label: "Name", },
         { type: "select", class: "col-12", filterable: false, multiple: true, clearable: true, options: [], validation: "required", model: "visuals", label: "Visuals", max_tag_count: 1},
         { type: "select", class: "col-12", filterable: false, multiple: true, clearable: true, options: [], validation: "", model: "filters", label: "Filters", max_tag_count: 1},
         { type: "select", class: "col-12", filterable: false, multiple: true, clearable: true, options: [], validation: "", model: "roles", label: "Roles", max_tag_count: 1},
         { type: "checkbox", class: "col-12 custom-check", validation: "required", model: "is_main_dashboard", label: "Is Main Dashboard", },
         { type: "textarea", class: "col-12", rows: "3", validation: "required|min:10|max:2000", model: "description", label: "Description", },

      ]
   },
}

let tables = {
   dashboard: {
      props: {
         icon: 'fa fa-chart-bar',
         title: 'Dashboards',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['code', 'name', 'visuals', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Code", key: "code", },
            { title: "Name", key: "name", },
            { title: "Total Visuals", slot: "visual_count", width: 180, align: 'center', sortable: true,},
            { title: "Last Update", slot: "date", width: 200, align: 'center'},

            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'View Dashboard', event: 'dashboard:Dashboards-View_Dashboard', icon: 'fa-chart-pie', allow_multiple: false },
            { type: 'menu', title: 'Edit', event: 'dashboard:edit', icon: 'fa-edit', allow_multiple: false },
            { type: 'menu', title: 'Delete', event: 'dashboard:delete', icon: 'fa-trash-alt', allow_multiple: true },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}